// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"d97d2769","373":"e12a81ea","753":"d117db8a"}[chunkId] + ".css";
};